module.exports = __webpack_public_path__ + "media/src/images/icon/sns/line-49192aa80ae0cfbd512cc5679c264e61.png";